import "./App.scss";
import ProjectCard, { Project } from "./components/ProjectCard";

const projects: Project[] = [
  {
    logo: "/product-images/layers-3d-banner.png",
    title: "Layers 3D",
    description:
      "Generate 3D assets from your Figma designs and render them in the browser.",
    url: "https://www.figma.com/community/plugin/1332288459623378370/layers-3d",
    tags: ["Plugin", "Web App", "Figma", "3D", "Design", "Threejs"],
  },
  {
    logo: "/product-images/easy-scribe-banner.png",
    title: "Easy Scribe",
    description:
      "Rich documentation, walkthroughs, and guides from screen recordings.",
    url: "https://www.easyscribe.guide/",
    tags: ["Web App", "Documentation", "Writing", "AI", "Productivity"],
  },
  {
    logo: "/product-images/membr-notes-banner.png",
    title: "Membr",
    description:
      "All your notes, within reach. Securely write notes and instantly access them across browser tabs.",
    url: "https://membrnotes.com/",
    tags: ["Extension", "Web App", "Writing", "Security", "AI"],
  },
  {
    logo: "/product-images/splash-easy-banner.png",
    title: "Splash Easy",
    description:
      "Generate all the needed splash-screen files for your Android and iOS applications.",
    url: "https://www.figma.com/community/plugin/935850798044023728/splash-easy",
    tags: ["Plugin", "Figma", "Design", "Mobile"],
  },
];

const App = () => {
  return (
    <div className="App">
      <div className="introduction">
        <img className="logo" alt="Logo" src="logo192.png" />
        <div className="copy">
          <h1>
            We design products that{" "}
            <span className="highlight">blend design and utility</span>. We
            believe digital products can have both style and substance. To that
            end, our focus is on story telling and the experience, as opposed to
            simply the interface.
          </h1>
        </div>
      </div>

      <div className="projects">
        {projects.map((project) => (
          <ProjectCard key={project.title} project={project} />
        ))}
      </div>

      <div className="footer">
        <p>
          <a href="mailto:hello@crystalbridge.llc">hello@crystalbridge.llc</a>
        </p>
        <p className="copyright">
          &copy; 2026 CrystalBridge. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default App;
